import {
  TRAINING_REGISTRATION_PAGE_UPDATE_FORM_FIELD,
  TRAINING_REGISTRATION_PAGE_TRIGGER_REQUEST,
  TRAINING_REGISTRATION_PAGE_UPDATE_REQUEST_STATE,
  TRAINING_REGISTRATION_PAGE_RESET_STATE,
} from '../constants/actionTypes';

import {
  REQUEST_UNSTARTED,
  REQUEST_SUCCESS,
  REQUEST_FETCHING,
  REQUEST_ERROR,
} from '../constants/requestStates';

export const resetTrainingRegistrationPage = () => {
  return {
    type: TRAINING_REGISTRATION_PAGE_RESET_STATE
  }
};

export const trainingRegistrationPageTriggerRequest = (key) => {
  return {
    type: TRAINING_REGISTRATION_PAGE_TRIGGER_REQUEST + key,
    payload: {
      key,
    }
  }
};

export const trainingRegistrationPageUpdateRequestState = (key, state, result=undefined) => {
  let payload = {
    state,
  };
  if (!!(result)) {
    if (state === REQUEST_SUCCESS || state === REQUEST_FETCHING || state === REQUEST_UNSTARTED) {
      payload.result = result
    }
    if (state === REQUEST_ERROR) {
      payload.error = result;
    }
  }
  return {
    type: TRAINING_REGISTRATION_PAGE_UPDATE_REQUEST_STATE,
    key,
    payload,
  }
}

export const trainingRegistrationPageUpdateFormField = (key, value) => {
  return {
    type: TRAINING_REGISTRATION_PAGE_UPDATE_FORM_FIELD,
    payload: {[key]: value}
  }
};
